module.exports = __webpack_public_path__ + "img/2.3c382f62.png";